__turbopack_context__.v({
  "button": "serving-counter-module__1GiKfa__button",
  "compact": "serving-counter-module__1GiKfa__compact",
  "counter": "serving-counter-module__1GiKfa__counter",
  "input": "serving-counter-module__1GiKfa__input",
  "inputDisplay": "serving-counter-module__1GiKfa__inputDisplay",
  "inputWrapper": "serving-counter-module__1GiKfa__inputWrapper",
  "label": "serving-counter-module__1GiKfa__label",
  "srvFade": "serving-counter-module__1GiKfa__srvFade",
  "wrapper": "serving-counter-module__1GiKfa__wrapper",
});
